export const DxMarkBrandV3 = () => (
    <svg
        width="44"
        height="44"
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 11C0 4.92487 4.92487 0 11 0H33C39.0751 0 44 4.92487 44 11V33C44 39.0751 39.0751 44 33 44H11C4.92487 44 0 39.0751 0 33V11Z"
            fill="#94C748"
        />
        <path
            d="M33.1979 24.5217L37.6936 31.1667H33.3132C32.8385 30.6206 32.3773 29.963 31.9689 29.3559C31.3424 28.4244 31.344 27.146 31.9913 26.2297L33.1979 24.5217Z"
            fill="#101214"
        />
        <path
            d="M26.5124 19.4786L22.0168 12.8335H26.3972C26.8719 13.3797 27.3331 14.0374 27.7415 14.6445C28.368 15.5759 28.3664 16.8544 27.719 17.7707L26.5124 19.4786Z"
            fill="#101214"
        />
        <path
            d="M32.9099 13.9607C33.3709 13.1893 33.8898 12.8927 34.6966 12.8927L38.27 12.8334L26.6452 30.4952C26.3932 30.8781 25.9746 31.1074 25.5272 31.1074H21.6277C25.3561 25.3789 29.3035 19.7688 32.9099 13.9607Z"
            fill="#101214"
        />
        <path
            d="M7.33264 31.1076H13.6526C19.3034 31.1076 22.7485 27.5549 22.7485 21.9974C22.7485 16.4401 19.3034 12.8873 13.6526 12.8873H7.33264L11.2519 16.4654H9.63809C8.36482 16.4654 7.33264 17.528 7.33264 18.8387V27.5295V31.1076ZM11.3725 27.5295V16.4654H13.6279C16.8499 16.4654 18.6591 18.6478 18.6591 21.9974C18.6591 25.3472 16.8499 27.5295 13.6526 27.5295H11.3725Z"
            fill="#101214"
        />
    </svg>
);
